// GDPR Art.30 data-processor registry — module-local data layer. REAL backend
// (/admin/data-processors). Reachable via the compliance dashboard.
import { api } from '@/lib/api'

export interface DataProcessor {
  id: number
  name: string
  purpose: string
  data_categories: string
  location: string
  contact: string
  dpa_signed: boolean
  status: string
  updated_at: string
}

export type ProcessorBody = Omit<DataProcessor, 'id' | 'updated_at'>

export const fetchProcessors = (status = '', s?: AbortSignal) =>
  api.get<{ processors: DataProcessor[] }>('/admin/data-processors', { query: status ? { status } : {}, ...(s ? { signal: s } : {}) }).then((d) => d.processors ?? [])
export const createProcessor = (body: ProcessorBody) => api.post<{ id: number }>('/admin/data-processors', body)
export const updateProcessor = (id: number, body: ProcessorBody) => api.put(`/admin/data-processors/${id}`, body)
export const deleteProcessor = (id: number) => api.del(`/admin/data-processors/${id}`)

export const DP_STR = {
  title: 'Реестр обработчиков данных',
  desc: 'GDPR ст.30 — третьи стороны, обрабатывающие данные пользователей + статус DPA',
  create: 'Новый обработчик',
  name: 'Название',
  purpose: 'Цель обработки',
  categories: 'Категории данных',
  location: 'Расположение',
  contact: 'Контакт',
  dpa: 'DPA подписан',
  status: 'Статус',
  active: 'Активен',
  terminated: 'Прекращён',
  save: 'Сохранить',
  edit: 'Изменить',
  add: 'Создать',
  delete: 'Удалить',
  cancel: 'Отмена',
  noDpa: 'Без DPA',
  done: 'Готово',
  failed: 'Ошибка',
  empty: 'Нет обработчиков',
  all: 'Все',
} as const
